module.exports = __webpack_public_path__ + "static/img/Canoe_VOD-Selected.9d01658.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Canoe_VOD-Selected.png
// module id = 602
// module chunks = 0